import React from 'react';

interface PlacementCaptureOverlayProps {
  active: boolean;
  onPointerMove: (e: React.PointerEvent) => void;
  onPointerDown: (e: React.PointerEvent) => void;
  onPointerUp: (e: React.PointerEvent) => void;
  onPointerCancel: (e: React.PointerEvent) => void;
}

/**
 * 配置モード中に SVG の上へ重ねる透明な入力捕捉レイヤ。
 * touch/pointer を全て自分で受けることで、モバイルの scroll container 側 touch 経路
 * (pan / 範囲選択) と干渉させない。ゴースト描画は PlacementGhost (SVG 子) が担う。
 */
const PlacementCaptureOverlay: React.FC<PlacementCaptureOverlayProps> = ({
  active, onPointerMove, onPointerDown, onPointerUp, onPointerCancel,
}) => {
  if (!active) return null;
  return (
    <div
      data-testid="placement-capture-overlay"
      className="absolute inset-0 z-40 cursor-crosshair"
      style={{ touchAction: 'none' }}
      onPointerMove={onPointerMove}
      onPointerDown={onPointerDown}
      onPointerUp={onPointerUp}
      onPointerCancel={onPointerCancel}
      onClick={(e) => e.stopPropagation()}
    />
  );
};

export default PlacementCaptureOverlay;
